var pug = require("!../../../../../.yarn/cache/pug-runtime-npm-3.0.1-13038c62ae-d34ee1b951.zip/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (comentario, device, dominio) {
      



pug_mixins["imagen"] = pug_interp = function(nombreImg, anchoImg, altoImg, pieFoto, retina, lazy){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (device !== 'amp') {
if (retina === undefined) {
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"loading": "lazy"},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg)},attributes]), true)) + "\u003E";
}
}
else {
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"srcset": pug.escape(nombreImg+", "+retina+" 2x"),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"loading": "lazy"},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"srcset": pug.escape(nombreImg+", "+retina+" 2x"),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg)},attributes]), true)) + "\u003E";
}
}
}
else {
pug_html = pug_html + "\u003Camp-img" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"alt": pug.escape(pieFoto),"layout": "responsive","width": pug.escape(anchoImg),"height": pug.escape(altoImg)},attributes]), true)) + "\u003E\u003C\u002Famp-img\u003E";
}
};









pug_mixins["imagenContenido"] = pug_interp = function(urlCompleta, anchoImg, altoImg, pieFoto, lazy, srcSet, sizes){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (device !== 'amp') {
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(urlCompleta),"alt": pug.escape(pieFoto),"width": pug.escape(srcSet?undefined:anchoImg),"height": pug.escape(srcSet?undefined:altoImg),"loading": "lazy","srcset": pug.escape(srcSet),"sizes": pug.escape(sizes)},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Clink" + (" rel=\"preload\""+pug.attr("href", urlCompleta, true, true)+" as=\"image\" fetchpriority=\"high\"") + "\u003E\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(urlCompleta),"alt": pug.escape(pieFoto),"width": pug.escape(srcSet?undefined:anchoImg),"height": pug.escape(srcSet?undefined:altoImg),"srcset": pug.escape(srcSet),"sizes": pug.escape(sizes),"fetchpriority": "high"},attributes]), true)) + "\u003E";
}
}
else {
pug_html = pug_html + "\u003Camp-img" + (pug.attrs(pug.merge([{"src": pug.escape(urlCompleta),"alt": pug.escape(pieFoto),"layout": "responsive","width": pug.escape(anchoImg),"height": pug.escape(altoImg),"srcset": pug.escape(srcSet),"sizes": pug.escape(sizes)},attributes]), true)) + "\u003E\u003C\u002Famp-img\u003E";
}
};








pug_mixins["icono"] = pug_interp = function(icon){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg" + (pug.attrs(pug.merge([{"class": "icono","viewBox": "0 0 24 24","width": "24","height": "24"},attributes]), true)) + "\u003E";
switch (icon){
case 'aspa':
pug_html = pug_html + "\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M0,13a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414l12-12a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-12,12A1,1,0,0,1,0,13Z\" transform=\"translate(6 6)\"\u002F\u003E\u003Cpath d=\"M12,13a1,1,0,0,1-.707-.293l-12-12a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0l12,12A1,1,0,0,1,12,13Z\" transform=\"translate(6 6)\"\u002F\u003E";
  break;
case 'buscar':
pug_html = pug_html + "\u003Cg transform=\"translate(-287 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(287 230)\" fill=\"none\"\u002F\u003E\u003Cg transform=\"translate(287 230)\"\u003E\u003Cpath d=\"M8-1A9,9,0,1,1-1,8,9.01,9.01,0,0,1,8-1ZM8,15A7,7,0,1,0,1,8,7.008,7.008,0,0,0,8,15Z\" transform=\"translate(3 3)\"\u002F\u003E\u003Cpath d=\"M4.35,5.35a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0l4.35,4.35A1,1,0,0,1,4.35,5.35Z\" transform=\"translate(16.65 16.65)\"\u002F\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E";
  break;
case 'calendario':
pug_html = pug_html + "\u003Cg transform=\"translate(-311 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(311 230)\" fill=\"none\"\u002F\u003E\u003Cg transform=\"translate(311 230)\"\u003E\u003Cpath d=\"M2-1H16a3,3,0,0,1,3,3V16a3,3,0,0,1-3,3H2a3,3,0,0,1-3-3V2A3,3,0,0,1,2-1ZM16,17a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2A1,1,0,0,0,1,2V16a1,1,0,0,0,1,1Z\" transform=\"translate(3 4)\"\u002F\u003E\u003Cpath d=\"M0,5A1,1,0,0,1-1,4V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V4A1,1,0,0,1,0,5Z\" transform=\"translate(16 2)\"\u002F\u003E\u003Cpath d=\"M0,5A1,1,0,0,1-1,4V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V4A1,1,0,0,1,0,5Z\" transform=\"translate(8 2)\"\u002F\u003E\u003Cpath d=\"M18,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H18a1,1,0,0,1,1,1A1,1,0,0,1,18,1Z\" transform=\"translate(3 10)\"\u002F\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E";
  break;
case 'check':
pug_html = pug_html + "\u003Cg transform=\"translate(-359 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(359 230)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M9,18a1,1,0,0,1-.707-.293l-5-5a1,1,0,1,1,1.414-1.414L9,15.586,19.293,5.293a1,1,0,0,1,1.414,1.414l-11,11A1,1,0,0,1,9,18Z\" transform=\"translate(359 231)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'comentarios':
pug_html = pug_html + "\u003Cg transform=\"translate(-479 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(479 230)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M12.478,2H13l.055,0A9.469,9.469,0,0,1,22,10.945q0,.028,0,.055v.5A9.5,9.5,0,0,1,12.5,21h-.022a9.431,9.431,0,0,1-3.844-.824L3.316,21.949a1,1,0,0,1-1.265-1.265l1.773-5.318A9.5,9.5,0,0,1,12.478,2Zm.493,2h-.493A7.495,7.495,0,0,0,5.793,14.849a1,1,0,0,1,.056.767l-1.268,3.8,3.8-1.268a1,1,0,0,1,.767.056A7.416,7.416,0,0,0,12.478,19H12.5A7.509,7.509,0,0,0,20,11.5v-.474A7.471,7.471,0,0,0,12.972,4Z\" transform=\"translate(479 230)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'compartir':
pug_html = pug_html + "\u003Cg transform=\"translate(-335 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(335 230)\" fill=\"none\"\u002F\u003E\u003Cg transform=\"translate(335 230)\"\u003E\u003Cpath d=\"M3-1A4,4,0,1,1-1,3,4,4,0,0,1,3-1ZM3,5A2,2,0,1,0,1,3,2,2,0,0,0,3,5Z\" transform=\"translate(15 2)\"\u002F\u003E\u003Cpath d=\"M3-1A4,4,0,1,1-1,3,4,4,0,0,1,3-1ZM3,5A2,2,0,1,0,1,3,2,2,0,0,0,3,5Z\" transform=\"translate(3 9)\"\u002F\u003E\u003Cpath d=\"M3-1A4,4,0,1,1-1,3,4,4,0,0,1,3-1ZM3,5A2,2,0,1,0,1,3,2,2,0,0,0,3,5Z\" transform=\"translate(15 16)\"\u002F\u003E\u003Cpath d=\"M6.829,4.98a1,1,0,0,1-.5-.136L-.5.864A1,1,0,0,1-.864-.5,1,1,0,0,1,.5-.864l6.83,3.98a1,1,0,0,1-.5,1.864Z\" transform=\"translate(8.59 13.51)\"\u002F\u003E\u003Cpath d=\"M0,4.98a1,1,0,0,1-.865-.5A1,1,0,0,1-.5,3.116l6.82-3.98A1,1,0,0,1,7.684-.5,1,1,0,0,1,7.324.864L.5,4.844A1,1,0,0,1,0,4.98Z\" transform=\"translate(8.59 6.51)\"\u002F\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E";
  break;
case 'desplegable':
pug_html = pug_html + "\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,0,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z\"\u002F\u003E";
  break;
case 'flechaDerecha':
pug_html = pug_html + "\u003Cg transform=\"translate(-407 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(407 230)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M5,23a1,1,0,0,1-.707-1.707L13.586,12,4.293,2.707A1,1,0,0,1,5.707,1.293l10,10a1,1,0,0,1,0,1.414l-10,10A1,1,0,0,1,5,23Z\" transform=\"translate(409 230)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'flechaIzquierda':
pug_html = pug_html + "\u003Cg transform=\"translate(-383 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(383 230)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M19,23a1,1,0,0,1-.707-.293l-10-10a1,1,0,0,1,0-1.414l10-10a1,1,0,0,1,1.414,1.414L10.414,12l9.293,9.293A1,1,0,0,1,19,23Z\" transform=\"translate(381 230)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'flechaMiniDerecha':
pug_html = pug_html + "\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M0,2v8a1,1,0,0,0,1.6.8l5.333-4a1,1,0,0,0,0-1.6L1.6,1.2A1,1,0,0,0,0,2Z\" transform=\"translate(8.333 6)\"\u002F\u003E";
  break;
case 'flechaSiguiente':
pug_html = pug_html + "\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M10,18a1,1,0,0,1-.707-1.707L13.586,12,9.293,7.707a1,1,0,0,1,1.414-1.414l5,5a1,1,0,0,1,0,1.414l-5,5A1,1,0,0,1,10,18Z\" transform=\"translate(6)\"\u002F\u003E\u003Cpath d=\"M17,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H17a1,1,0,0,1,1,1A1,1,0,0,1,17,1Z\" transform=\"translate(3 12)\"\u002F\u003E";
  break;
case 'galeria':
pug_html = pug_html + "\u003Cg transform=\"translate(0)\"\u003E\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M21,22H3a3,3,0,0,1-3-3V8A3,3,0,0,1,3,5H6.465l1.7-2.555A1,1,0,0,1,9,2h6a1,1,0,0,1,.832.445L17.535,5H21a3,3,0,0,1,3,3V19A3,3,0,0,1,21,22ZM3,7A1,1,0,0,0,2,8V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H17a1,1,0,0,1-.832-.445L14.465,4H9.535l-1.7,2.555A1,1,0,0,1,7,7Z\"\u002F\u003E\u003Cpath d=\"M4-1A5,5,0,1,1-1,4,5.006,5.006,0,0,1,4-1ZM4,7A3,3,0,1,0,1,4,3,3,0,0,0,4,7Z\" transform=\"translate(8 9)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'galeriaIcon':
pug_html = pug_html + "\u003Cg width=\"48px\" height=\"40px\"\u003E\n\u003Cg filter=\"url(#filter0_d_2265_22995)\"\u003E\n\u003Ccircle cx=\"24\" cy=\"20\" r=\"20\" fill=\"#DA291C\"\u002F\u003E\n\u003C\u002Fg\u003E\n\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.7639 11C26.9002 11 27.939 11.642 28.4472 12.6584L29.3416 14.4472C29.511 14.786 29.8573 15 30.2361 15H31C32.6569 15 34 16.3431 34 18V26C34 27.6569 32.6569 29 31 29H17C15.3431 29 14 27.6569 14 26V18C14 16.3431 15.3431 15 17 15H17.7639C18.1427 15 18.489 14.786 18.6584 14.4472L19.5528 12.6584C20.061 11.642 21.0998 11 22.2361 11H25.7639ZM25.7639 13H22.2361C21.8573 13 21.511 13.214 21.3416 13.5528L20.4472 15.3416C19.939 16.358 18.9002 17 17.7639 17H17C16.4477 17 16 17.4477 16 18V26C16 26.5523 16.4477 27 17 27H31C31.5523 27 32 26.5523 32 26V18C32 17.4477 31.5523 17 31 17H30.2361C29.0998 17 28.061 16.358 27.5528 15.3416L26.6584 13.5528C26.489 13.214 26.1427 13 25.7639 13ZM24 17C26.2091 17 28 18.7909 28 21C28 23.2091 26.2091 25 24 25C21.7909 25 20 23.2091 20 21C20 18.7909 21.7909 17 24 17ZM24 19C22.8954 19 22 19.8954 22 21C22 22.1046 22.8954 23 24 23C25.1046 23 26 22.1046 26 21C26 19.8954 25.1046 19 24 19Z\" fill=\"#F2F2F2\"\u002F\u003E\n\u003Cdefs\u003E\n\u003Cfilter id=\"filter0_d_2265_22995\" x=\"0\" y=\"0\" width=\"48\" height=\"48\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"\u003E\n\u003CfeFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"\u002F\u003E\n\u003CfeColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"\u002F\u003E\n\u003CfeOffset dy=\"4\"\u002F\u003E\n\u003CfeGaussianBlur stdDeviation=\"2\"\u002F\u003E\n\u003CfeComposite in2=\"hardAlpha\" operator=\"out\"\u002F\u003E\n\u003CfeColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"\u002F\u003E\n\u003CfeBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2265_22995\"\u002F\u003E\n\u003CfeBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2265_22995\" result=\"shape\"\u002F\u003E\n\u003C\u002Ffilter\u003E\n\u003C\u002Fdefs\u003E\n\u003C\u002Fg\u003E\n";
  break;
case 'masHorizontal':
pug_html = pug_html + "\u003Crect width=\"24\" height=\"24\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M1-1A2,2,0,1,1-1,1,2,2,0,0,1,1-1Z\" transform=\"translate(11 11)\"\u002F\u003E\u003Cpath d=\"M1-1A2,2,0,1,1-1,1,2,2,0,0,1,1-1Z\" transform=\"translate(18 11)\"\u002F\u003E\u003Cpath d=\"M1-1A2,2,0,1,1-1,1,2,2,0,0,1,1-1Z\" transform=\"translate(4 11)\"\u002F\u003E";
  break;
case 'menu':
pug_html = pug_html + "\u003Cg transform=\"translate(-431 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(431 230)\" fill=\"none\"\u002F\u003E\u003Cg transform=\"translate(431 230)\"\u003E\u003Cpath d=\"M15,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H15a1,1,0,0,1,1,1A1,1,0,0,1,15,1Z\" transform=\"translate(3 12)\"\u002F\u003E\u003Cpath d=\"M18,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H18a1,1,0,0,1,1,1A1,1,0,0,1,18,1Z\" transform=\"translate(3 6)\"\u002F\u003E\u003Cpath d=\"M12,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12a1,1,0,0,1,1,1A1,1,0,0,1,12,1Z\" transform=\"translate(3 18)\"\u002F\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E";
  break;
case 'puntaAbajo':
pug_html = pug_html + "\u003Cg transform=\"translate(-359 -254)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(359 254)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,0,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z\" transform=\"translate(359.5 254.5)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'puntaArriba':
pug_html = pug_html + "\u003Cg transform=\"translate(-311 -254)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(311 254)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M18,16a1,1,0,0,1-.707-.293L12,10.414,6.707,15.707a1,1,0,0,1-1.414-1.414l6-6a1,1,0,0,1,1.414,0l6,6A1,1,0,0,1,18,16Z\" transform=\"translate(311.5 254.5)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'puntaDerecha':
pug_html = pug_html + "\u003Cg transform=\"translate(-335 -254)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(335 254)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M9,19a1,1,0,0,1-.707-1.707L13.586,12,8.293,6.707A1,1,0,1,1,9.707,5.293l6,6a1,1,0,0,1,0,1.414l-6,6A1,1,0,0,1,9,19Z\" transform=\"translate(335.5 254.5)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'puntaIzquierda':
pug_html = pug_html + "\u003Cg transform=\"translate(-287 -254)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(287 254)\" fill=\"none\"\u002F\u003E\u003Cpath d=\"M15,19a1,1,0,0,1-.707-.293l-6-6a1,1,0,0,1,0-1.414l6-6a1,1,0,0,1,1.414,1.414L10.414,12l5.293,5.293A1,1,0,0,1,15,19Z\" transform=\"translate(287.5 254.5)\"\u002F\u003E\u003C\u002Fg\u003E";
  break;
case 'usuario':
pug_html = pug_html + "\u003Cg transform=\"translate(-455 -230)\"\u003E\u003Crect width=\"24\" height=\"24\" transform=\"translate(455 230)\" fill=\"none\"\u002F\u003E\u003Cg transform=\"translate(455 230)\"\u003E\u003Cpath d=\"M18,22a1,1,0,0,1-1-1V19a3,3,0,0,0-3-3H10a3,3,0,0,0-3,3v2a1,1,0,0,1-2,0V19a5,5,0,0,1,5-5h4a5.006,5.006,0,0,1,5,5v2A1,1,0,0,1,18,22Z\"\u002F\u003E\u003Cpath d=\"M4-1A5,5,0,1,1-1,4,5.006,5.006,0,0,1,4-1ZM4,7A3,3,0,1,0,1,4,3,3,0,0,0,4,7Z\" transform=\"translate(8 3)\"\u002F\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E";
  break;
case 'rrssFacebook':
pug_html = pug_html + "\u003Cpath d=\"M16.5,3l0,3.375l-2.25,0c-0.617,0 -1.125,0.508 -1.125,1.125l0,2.25l3.375,0l0,3.375l-3.375,0l0,7.875l-3.375,0l0,-7.875l-2.25,0l0,-3.375l2.25,0l0,-2.813c0,-2.182 1.766,-3.937 3.938,-3.937l2.812,0Z\"\u002F\u003E";
  break;
case 'rrssInstagram':
pug_html = pug_html + "\u003Cpath d=\"M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z\" \u002F\u003E";
  break;
case 'rrssTwitter':
pug_html = pug_html + "\u003Cpath d=\"M21,6.265c-0.663,0.309 -1.377,0.511 -2.117,0.609c0.758,-0.468 1.343,-1.209 1.618,-2.1c-0.714,0.441 -1.506,0.75 -2.34,0.926c-0.68,-0.759 -1.635,-1.2 -2.719,-1.2c-2.022,0 -3.674,1.694 -3.674,3.785c0,0.3 0.034,0.591 0.094,0.865c-3.063,-0.159 -5.79,-1.668 -7.606,-3.953c-0.318,0.556 -0.499,1.209 -0.499,1.897c0,1.315 0.645,2.48 1.644,3.141c-0.611,0 -1.179,-0.176 -1.678,-0.441l0,0.027c0,1.835 1.273,3.37 2.96,3.714c-0.31,0.089 -0.637,0.133 -0.973,0.133c-0.232,0 -0.464,-0.027 -0.688,-0.071c0.465,1.491 1.815,2.603 3.442,2.629c-1.257,1.024 -2.848,1.624 -4.586,1.624c-0.293,0 -0.585,-0.018 -0.878,-0.053c1.635,1.077 3.579,1.703 5.662,1.703c6.78,0 10.505,-5.771 10.505,-10.774c0,-0.167 0,-0.326 -0.008,-0.494c0.722,-0.529 1.342,-1.2 1.841,-1.967Z\"\u002F\u003E";
  break;
case 'rrssTelegram':
pug_html = pug_html + "\u003Cpath id=\"telegram-1\" d=\"M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z\"\u002F\u003E\n";
  break;
case 'rrssX':
pug_html = pug_html + "\u003Csvg viewBox=\"0 0 24 24\"\u003E\u003Cpath d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z\"\u003E\u003C\u002Fpath\u003E\u003C\u002Fsvg\u003E\n";
  break;
case 'rrssWhatsapp':
pug_html = pug_html + "\u003Cpath d=\"M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z\" \u002F\u003E\n";
  break;
case 'rrssYoutube':
pug_html = pug_html + "\u003Cpath d=\"M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z\" \u002F\u003E";
  break;
case 'rrssTikTok':
pug_html = pug_html + "\u003C?xml version=\"1.0\" encoding=\"utf-8\"?\u003E\n\u003C!-- Generator: Adobe Illustrator 28.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\u003E\n\u003Csvg version=\"1.1\" id=\"Capa_1\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xmlns:xlink=\"http:\u002F\u002Fwww.w3.org\u002F1999\u002Fxlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 50 50\" style=\"enable-background:new 0 0 50 50;\" xml:space=\"preserve\"\u003E\n\u003Cstyle type=\"text\u002Fcss\"\u003E\n\t.st0{fill:#7E7C66;}\n\u003C\u002Fstyle\u003E\n\u003Cpath class=\"st0\" d=\"M41,4H9C6.2,4,4,6.2,4,9v32c0,2.8,2.2,5,5,5h32c2.8,0,5-2.2,5-5V9C46,6.2,43.8,4,41,4z M37,22.3\n\tc-0.2,0-0.5,0-0.7,0c-2.6,0-4.9-1.3-6.3-3.4c0,5.3,0,11.4,0,11.5c0,4.7-3.8,8.5-8.5,8.5S13,35.2,13,30.5s3.8-8.5,8.5-8.5\n\tc0.2,0,0.4,0,0.5,0v4.2c-0.2,0-0.3-0.1-0.5-0.1c-2.4,0-4.4,1.9-4.4,4.4s1.9,4.4,4.4,4.4S26,33,26,30.6c0-0.1,0-19.6,0-19.6h4\n\tc0.4,3.6,3.3,6.4,6.9,6.7V22.3z\"\u002F\u003E\n\u003C\u002Fsvg\u003E\n";
  break;
case 'video':
pug_html = pug_html + "\u003Cpath fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" d=\"M6.51,0.83l14.4,9.6c1.49,0.87,1.58,2.95,0.26,3.97L6.51,24.17\n\tC4.91,25.1,2.9,23.95,2.9,22.1V2.9C2.9,1.05,4.91-0.1,6.51,0.83z\"\u002F\u003E\n";
  break;
case 'reproduciendo':
pug_html = pug_html + "\u003Cpath class=\"bars\" d=\"M10.731 17.46H6.923V5.515h3.808V25.46Zm6.347 0H13.27V.987h3.808v8.473Zm-16.502 0h3.808v-7.084H.576v5.084Zm22.85 0h-3.809V13.598h3.808V17.46Z\" clip-rule=\"evenodd\" fill=\"#fff\" fill-rule=\"evenodd\" style=\"visibility: hidden;\"\u003E\u003C\u002Fpath\u003E \u003Cpath class=\"bars\" d=\"M10.731 17.46H6.923V15h3.808V5.46Zm6.347 0H13.27V7.987h3.808v8.473Zm-16.502 0h3.808v-15.084H.576v.084Zm22.85 0h-3.809V4.598h3.808V17.46Z\" fill=\"#fff\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" style=\"visibility: hidden;\"\u003E\u003C\u002Fpath\u003E \u003Cpath class=\"bars\" d=\"M10.731 17.46H6.923V1h3.808V2.46Zm6.347 0H13.27V12.987h3.808v8.473Zm-16.502 0h3.808v-14.084H.576v.084Zm22.85 0h-3.809V5.598h3.808V17.46Z\" fill=\"#fff\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" style=\"visibility: hidden;\"\u003E\u003C\u002Fpath\u003E \u003Cpath class=\"bars\" d=\"M10.731 17.46H6.923V.515h3.808V17.46Zm6.347 0H13.27V8.987h3.808v8.473Zm-16.502 0h3.808v-5.084H.576v5.084Zm22.85 0h-3.809V5.598h3.808V17.46Z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\" fill=\"#fff\" style=\"\u002F* visibility: hidden; *\u002F\"\u003E\u003C\u002Fpath\u003E\n";
  break;
case 'google':
pug_html = pug_html + "\u003Cpath d=\"M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z\" fill=\"#4285F4\"\u002F\u003E\u003Cpath d=\"M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z\" fill=\"#34A853\"\u002F\u003E\u003Cpath d=\"M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z\" fill=\"#FBBC05\"\u002F\u003E\u003Cpath d=\"M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z\" fill=\"#EA4335\"\u002F\u003E\u003Cpath d=\"M1 1h22v22H1z\" fill=\"none\"\u002F\u003E\n";
  break;
}
pug_html = pug_html + "\u003C\u002Fsvg\u003E";
};









pug_mixins["botonIcono"] = pug_interp = function(tag, icono, accion, href, target){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (tag === 'a') {
if (target === undefined) {
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": "boton solo-icono","href": pug.escape(href),"title": pug.escape(accion)},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": "boton solo-icono","href": pug.escape(href),"title": pug.escape(accion),"target": pug.escape(target)},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
}
else {
if (accion === 'Compartir') {
pug_html = pug_html + "\u003C" + (tag) + (pug.attrs(pug.merge([{"class": "boton solo-icono boton-share"},attributes]), true)) + "\u003E";
pug_mixins["imagen"]('/img/compartir.svg','24','24','Compartir');
pug_html = pug_html + "\u003C\u002F" + (tag) + "\u003E";
}
else {
pug_html = pug_html + "\u003C" + (tag) + (pug.attrs(pug.merge([{"class": "boton solo-icono"},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002F" + (tag) + "\u003E";
}
}
};











































































































pug_mixins["filaClasificacion"] = pug_interp = function(puesto, imagen, equipo, corto, clase, variacion, ptsTotales, pjTotales, pgTotales, peTotales, ppTotales, gfTotales, gcTotales, ptsCasa, pjCasa, pgCasa, peCasa, ppCasa, gfCasa, gcCasa, ptsFuera, pjFuera, pgFuera, peFuera, ppFuera, gfFuera, gcFuera, portadilla, selecciones){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes([clase], [true]), false, true)) + "\u003E\u003Ctd class=\"equipo\"\u003E\u003Cdiv" + (pug.attrs(pug.merge([{"class": "pila"},attributes]), true)) + "\u003E\u003Cspan class=\"posicion\"\u003E" + (pug.escape(null == (pug_interp = puesto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan" + (pug.attr("class", pug.classes([['tescudo', selecciones ? 'flag' : ''].join(' ')], [true]), false, true)) + "\u003E";
pug_mixins["imagen"](imagen.normal, '24', '24', equipo, imagen.retina);
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cspan class=\"label\"\u003E";
if (portadilla) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", portadilla, true, true)) + "\u003E\u003Cspan class=\"solo-desktop\"\u003E" + (pug.escape(null == (pug_interp = equipo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"solo-movil\"\u003E" + (pug.escape(null == (pug_interp = corto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"solo-desktop\"\u003E" + (pug.escape(null == (pug_interp = equipo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"solo-movil\"\u003E" + (pug.escape(null == (pug_interp = corto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
if (clase.split(' ').includes('sube')) {
pug_mixins["icono"].call({
attributes: {"class": "sube"}
}, 'puntaArriba');
}
else
if (clase.split(' ').includes('baja')) {
pug_mixins["icono"].call({
attributes: {"class": "baja"}
}, 'puntaAbajo');
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"total fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsTotales) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = pjTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = pgTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = peTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = ppTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = gfTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = gcTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsCasa) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = pjCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = pgCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = peCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = ppCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = gfCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = gcCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsFuera) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = pjFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = pgFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = peFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = ppFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = gfFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = gcFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
};








































































































































































pug_mixins["autor"] = pug_interp = function(autor, compartir, fecha, fecha_formateada, fecha_amigable, lectura, titular, titularRrss, idCompartir, url, params){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"firma-portada pila flex-align-center nota\"\u003E";
if ((!params || params && params.avatar)) {
if (autor.foto !== undefined) {
if (autor.url !== undefined) {
pug_html = pug_html + "\u003Cspan class=\"tavatar\"\u003E\u003Ca" + (" class=\"avatar\""+pug.attr("href", url, true, true)+pug.attr("title", autor.apodo, true, true)) + "\u003E";
pug_mixins["imagen"](autor.foto, '32', '32', autor.apodo, autor.foto2x);
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"tavatar\"\u003E";
pug_mixins["imagen"].call({
attributes: {"class": "avatar"}
}, autor.foto, '32', '32', autor.apodo, autor.foto2x);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
}
}
pug_html = pug_html + "\u003Cspan class=\"datos\"\u003E\u003Cspan class=\"pila flex-align-center\"\u003E";
if (autor.url !== undefined) {
pug_html = pug_html + "\u003Ca" + (" class=\"enlace-oscuro\""+pug.attr("href", autor.url, true, true)+pug.attr("title", autor.apodo, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = autor.apodo) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"enlace-oscuro\"\u003E" + (pug.escape(null == (pug_interp = autor.apodo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003C!--if (params && params.fechaAmigable)--\u003E\u003C!--  time.uTime.texto-suave(data=fecha) #{fecha_amigable}--\u003E\u003C!--else--\u003E\u003Ctime" + (" class=\"uTime texto-oscuro\""+pug.attr("data", fecha, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = fecha_formateada) ? "" : pug_interp)) + "\u003C\u002Ftime\u003E\u003C\u002Fspan\u003E";
if (compartir) {
pug_mixins["botonIcono"].call({
attributes: {"for": pug.escape(idCompartir)}
}, 'label', 'compartir', 'Compartir', '');
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cinput" + (" class=\"oculto compartir-portada\""+" type=\"checkbox\""+pug.attr("id", idCompartir, true, true)+pug.attr("name", idCompartir, true, true)) + "\u003E\u003Cdiv class=\"capa-compartir fondo-negro-transparente flex-center flex-align-center flex-vertical\"\u003E";
if (block) {
block && block();
}
pug_html = pug_html + "\u003Cp class=\"texto-blanco texto-centrado titulo-1\"\u003E" + (pug.escape(null == (pug_interp = titular) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"botonera centro\"\u003E";
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-facebook"}
}, 'a', 'rrssFacebook', 'Compartir en Facebook', 'https://www.facebook.com/sharer.php?u=' + url, '_blank');
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-twitter"}
}, 'a', 'rrssX', 'Compartir en X', 'https://twitter.com/intent/tweet?text=' + titularRrss + '&url=' + url + '&related=&via=Estadio_ED', '_blank');
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-whatsapp"}
}, 'a', 'rrssWhatsapp', 'Compartir en Whatsapp', 'https://api.whatsapp.com/send?text=' + titularRrss + '%20' + url, '_blank');
pug_mixins["botonIcono"].call({
attributes: {"for": pug.escape(idCompartir)}
}, 'label', 'aspa', '', '');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};














pug_mixins["entradaDirecto"] = pug_interp = function(dominio, comentario){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (" class=\"narracion-entrada pila v-movil\""+pug.attr("data-comentario", comentario.id, true, true)+pug.attr("data-longitud", comentario.longitud, true, true)) + "\u003E";
if (comentario.temporalText && comentario.temporalText != '') {
pug_html = pug_html + "\u003Ctime class=\"entrada-hora menor fondo-alt\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = comentario.temporalText + (comentario.temporalTextTipo == 'minuto' ? '\'':'')) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftime\u003E\u003Cspan" + (pug.attr("class", pug.classes(["contenido-entrada","pila-v",(comentario.destacado ? 'fijada' : '')], [false,false,true]), false, true)) + "\u003E";
pug_mixins["comentarioDirecto"](dominio, comentario.tipo, (comentario.icono ? comentario.icono : undefined), comentario.comentario_html, comentario.destacado);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(["contenido-entrada","pila-v",(comentario.destacado ? 'fijada' : '')], [false,false,true]), false, true)) + "\u003E";
pug_mixins["comentarioDirecto"](dominio, comentario.tipo, (comentario.icono ? comentario.icono : undefined), comentario.comentario_html, comentario.destacado);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["comentarioDirecto"] = pug_interp = function(dominio, tipo, icono, comentario, destacado){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["pila",(tipo=='opinion' ? 'fondo-enlace' : (tipo == 'destacado' ? 'fondo-alt': ''))], [false,true]), false, true)) + "\u003E";
if (icono) {
pug_html = pug_html + "\u003Cimg" + (" class=\"icono-directo\""+pug.attr("src", dominio+'/img/directo/'+icono.file, true, true)+pug.attr("alt", icono.nombre, true, true)) + "\u003E";
}
if (comentario) {
if ((!destacado)) {
pug_html = pug_html + "\u003Cspan class=\"pila-v ancho-completo\"\u003E" + (null == (pug_interp = comentario) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"pila-v ancho-completo fijada\"\u003E\u003Cdiv class=\"contenido-pin\"\u003E" + (null == (pug_interp = comentario) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
pug_mixins["imagen"].call({
attributes: {"class": "icono-pin"}
}, '/img/pin.svg','15','15','Comentario fijado');
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};






pug_mixins["entradaDirecto"](dominio, comentario);
    }.call(this, "comentario" in locals_for_with ?
        locals_for_with.comentario :
        typeof comentario !== 'undefined' ? comentario : undefined, "device" in locals_for_with ?
        locals_for_with.device :
        typeof device !== 'undefined' ? device : undefined, "dominio" in locals_for_with ?
        locals_for_with.dominio :
        typeof dominio !== 'undefined' ? dominio : undefined));
    ;;return pug_html;};
module.exports = template;